@if (visible) {
  <div class="modal-backdrop" [style.z-index]="zIndex" (click)="close.emit()">
    <div #modalEl class="modal modal--{{ size }}" (click)="$event.stopPropagation()"
         (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">

      <!-- Swipe handle (mobile only) -->
      @if (swipeToClose) {
        <div class="modal__drag-handle" aria-hidden="true"></div>
      }

      <!-- Header -->
      <div class="modal__header">
        <div class="modal__header-text">
          <h2 class="modal__title">{{ title }}</h2>
          @if (subtitle) {
            <p class="modal__subtitle">{{ subtitle }}</p>
          }
        </div>
        <button class="modal__close" type="button" (click)="close.emit()" aria-label="Fechar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body — conteúdo projetado via ng-content -->
      <div class="modal__body">
        <ng-content />
      </div>

      <!-- Footer opcional — projetado via [modal-footer] -->
      <ng-content select="[modal-footer]" />

    </div>
  </div>
}

